import React from 'react';
import ReactDOM from 'react-dom/client';
import BearingSpringRates from './BearingSpringRates';

const $root: HTMLElement | null = document.getElementById(
	'timken-tool-bearing-spring-rates',
);

if ( $root ) {
	ReactDOM.createRoot( $root ).render(
		<React.StrictMode>
			<BearingSpringRates />
		</React.StrictMode>
	);
}
